module.exports = __webpack_public_path__ + "static/media/pasar-itv.38048df7.png";